import {durationLabel, durationOptions} from '@/lib/duration';

export default function DurationSelect({value, onChange, className, ...props}) {
  // A historical duration can still be displayed exactly; new choices use half hours.
  const legacy = Number(value) > 0 && !durationOptions.includes(Number(value));
  return <select {...props} className={className || 'mt-1 min-h-11 w-full rounded-lg border bg-background p-2'}
    value={value} onChange={onChange}>
    {legacy && <option value={value} disabled>{durationLabel(value)}</option>}
    {durationOptions.map(minutes => <option key={minutes} value={minutes}>{durationLabel(minutes)}</option>)}
  </select>;
}
